<template>
	<div>
		<!-- Policy Holder -->
		<div class="xs-12 fs5 fw7 mb2">Policyholder</div>
		<case-form :schema="schemaPolicyholder" headline="1. (a) (b) Policyholder" />

		<!-- Contact Person -->
		<div class="xs-12 fs5 fw7 mt6 mb2">Contact Person</div>
		<case-form :schema="schemaContactPerson" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "SHProposalPolicyholder",
	components: { CaseForm },

	computed: {
		schemaPolicyholder() {
			return [
				// {
				// 	label: "Test",
				// 	component: "entityFact",
				// 	bindTo: "case.holder.facts.testendoFactando",
				// 	entity: "case.holder",
				// 	relation: "case.holder.facts",
				// 	props: {
				// 		createOptions: {
				// 			dataType: "number"
				// 		}
				// 	}
				// },
				{
					label: "Select Policyholder",
					component: "entitySelect",
					bindTo: "case.holder",
					entity: "case.holder",
					props: {
						allowedEntityTypes: ["company"]
					}
				},
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: "case.facts.holderAddressId",
					props: {
						suggest: {
							typeIncludes: "main"
						},
						createOptions: {
							type: "main"
						}
					}
				},
				{
					label: "Nature of Business",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "natureOfBusiness",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Pawn Broker",
										value: "Pawn Broker"
									},
									{
										name: "Director",
										value: "Director"
									},
									{
										name: "Money Exchange",
										value: "Money Exchange"
									},
									{
										name: "Office",
										value: "Office"
									},
									{
										name: "Pawn Shop",
										value: "Pawn Shop"
									},
									{
										name: "Retail",
										value: "Retail"
									},
									{
										name: "Retail Shop",
										value: "Retail Shop"
									},
									{
										name: "Trading",
										value: "Trading"
									},
									{
										name: "Wholesale",
										value: "Wholesale"
									}
								]
							}
						}
					}
				},
				{
					label: "Territorial Limits",
					component: "text",
					bindTo: "case.facts.territorialLimits"
				},
				{
					label: "Underwriter Approval",
					component: "text",
					bindTo: "case.facts.underwriterApproval"
				}
			]
		},

		schemaContactPerson() {
			return [
				{
					label: "Name",
					component: "text",
					bindTo: "case.facts.contactPersonName"
				},
				{
					label: "Title",
					component: "select",
					bindTo: "case.facts.contactPersonTitle",
					props: {
						options: [
							{
								name: "Mr.",
								value: "Mr"
							},
							{
								name: "Mrs.",
								value: "Mrs"
							},
							{
								name: "Ms.",
								value: "Ms"
							},
							{
								name: "Miss",
								value: "Miss"
							},
							{
								name: "Dr.",
								value: "Dr"
							}
						]
					}
				},
				{
					label: "Email",
					component: "text",
					bindTo: "case.facts.contactPersonEmail"
				},
				{
					label: "Mobile",
					component: "text",
					bindTo: "case.facts.contactPersonMobile"
				},
				{
					label: "Tel",
					component: "text",
					bindTo: "case.facts.contactPersonTelephone"
				},
				{
					label: "Fax",
					component: "text",
					bindTo: "case.facts.contactPersonFax"
				}
			]
		}
	}
}
</script>
